/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ByAddressRequestBuilderRequestsMetadata, type ByAddressRequestBuilder } from './byAddress/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /meteringpoints
 */
export interface MeteringpointsRequestBuilder extends BaseRequestBuilder<MeteringpointsRequestBuilder> {
    /**
     * The byAddress property
     */
    get byAddress(): ByAddressRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const MeteringpointsRequestBuilderUriTemplate = "{+baseurl}/meteringpoints";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const MeteringpointsRequestBuilderNavigationMetadata: Record<Exclude<keyof MeteringpointsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byAddress: {
        requestsMetadata: ByAddressRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
